export default __webpack_public_path__ + "static/media/GA_Snappy-1.d8aeee24.wav";